const base = {
  'c.HeadTooBar.slogan': 'قطع غيار عالية الجودة، مصدر عالمي شامل في محطة واحدة',
  'c.HeadTooBar.modifyPassword': 'تعديل كلمة المرور',
  'c.HeadTooBar.logout': 'شطب',
  'c.HeadTooBar.signUp': 'التسجيل في',
  'c.HeadTooBar.login': 'تسجيل الدخول',
  'c.HeadTooBar.helpCenter': 'مركز المساعدة',

  'base.button.login': 'تسجيل الدخول',
  'base.button.ok': 'حسنا',
  'base.message.pleaseLogin': 'يرجى تسجيل الدخول للوصول',

  'base.language': 'اللغة',
  'base.countryorregion': 'الدولة/المنطقة',
  'base.currency': 'العملة',
  'base.currency.placeholder': 'يرجى تحديد العملة',

  'base.noData': 'بيانات مؤقتة',
  'base.OE': 'رقم القطعة',

  'menu.home': 'الصفحة الرئيسية',
  'menu.product': 'كتالوج الأجزاء',
  copyright:
    'حقوق النشر © 2015 - الآن CassTime. جميع الحقوق محفوظة: شركة تكنولوجيا العصر المفتوح المحدودة، شنتشن',

  'home.vehicleBrandTitle': 'مقدمة عن ميزات قطع غيار {vehicleBrand}',
  'home.AccessoriesClassification': 'تصنيف الأجزاء',
  'home.comingSoon': 'تعال حالاً',

  'productList.total': 'تم العثور على {total} نتائج من أجلك',
  'productList.priceTips': '*السعر المعروض هو EXW، والأسعار الفعلية قد تختلف باختلاف كمية الطلب',
  'productList.loginToView': 'تسجيل الدخول لرؤية',
  'productList.filter.oe.placeholder': 'رقم OE أو اسم القطعة',
  'productList.circulationRating': 'التقييم الدوري',
  'productList.contactUs': 'اتصل بنا',
  'productList.addToList': 'إضافة قائمة',
  'productList.removeList': 'إزالة قائمة',
  'productList.contactUs.web': 'نسخة الويب',
  'productList.contactUs.template': 'مرحبا ، أود أن أعرف ما يلي عن هذا المنتج :',
  'productList.applicableVehicleTypes': 'أنواع المركبات المناسبة',
  'productList.approximately': 'تقريبًا',

  'pagination.total': 'مجموع {total} قاعدة',

  'base.message.apiError': 'النظام مشغول! يرجى المحاولة مرة أخرى لاحقًا.',
  'base.remark.placeholder': 'يرجى إدخال الملاحظات',
  'base.remark.maxLength': 'لا يمكن أن يتجاوز الملاحظات {total} حرفًا',

  'base.remark': 'ملاحظات',

  'base.copy': 'نسخ',
  'base.copied': 'تم نسخها',

  'page.title.addressList': 'إدارة العناوين',
  'page.title.orderList': 'إدارة الطلبات',
  'page.title.orderDetails': 'تفاصيل الطلب',
  'page.title.orderConfirmation': 'تأكيد الطلب',

  'base.noLogin.getInfoError':
    'فشل في الحصول على معلومات المستخدم، يرجى تحديث الصفحة والمحاولة مرة أخرى',
  'base.api.error': 'الظام مشغول! يرجى المحاولة لاحقًا.',

  'base.creator': 'المنشئ',
  'base.createdDate': 'وقت الإنشاء',
  'base.operation': 'الإجراء',
  'base.detail': 'التفاصيل',

  'base.attachment': 'المرفقات',
  'base.form.checkForm': 'يرجى مراجعة محتويات النموذج',
  'base.index': 'الرقم التسلسلي',
  'base.status': 'الحالة',
  'base.quantity': 'الكمية',

  'base.HeadTooBar.getUserInfoFailed':
    'فشل في الحصول على معلومات المستخدم، يرجى تحديث الصفحة والمحاولة مرة أخرى',

  Search: 'بحث',
  Action: 'الإجراء',
  Delivery: 'التوصيل',
  total_days: '{total} يوم',
  Item: 'العنصر',
  Price_currency: 'السعر ({currency})',

  total_Parts: '{total} قطع',
  total_parts: '{total} قطع',
  Show_all: 'عرض الكل',
  Collapse: 'طي',
  Part_name: 'اسم القطعة',
  Brand: 'العلامة التجارية',
  Part_number: 'رقم القطعة',
  Description: 'الوصف',
  loading: 'جاري التحميل...',
};

export default base;
